/**
 * 가상계좌관리 (/adm/account/bulk) — 회원별 가상계좌 연결 상태 목록과 연결/해지 변경
 * ($j.Pages.Admin.BulkAccount / body data-page-name="BulkAccount")
 */
export default class BulkAccount {
    initialize() {
    let $table = null;

    $(function () {
        loadTable();
    });
    $('#find-user-search-btn').on('click', search);
    // 연결 상태 → 상태 변경 모달 (회원번호·이름·현재 상태는 data-*)
    $('#table').on('click', 'a.ba-status-link', function (e) {
        e.preventDefault();
        openStatusModal(this.dataset.mbNo, this.dataset.name, this.dataset.status);
    });

    // 연결상태 모달 닫기
    $('#close-modal').on('click', function () {
        $('#statusModal').hide();
    });

    // 해지 사유 select 변경 시
    $('#reasonSelect').on('change', function () {
        const selected = $(this).val();
        // 기타 사유칸은 .form-control(block) 이라 show() 대신 클래스로 연다
        $('#customReason').toggleClass('ba-off', selected !== '기타');
    });

    // 라디오 버튼 선택 시 동작
    $('input[name="modalStatus"]').on('change', function () {
        toggleReasonSection($(this).val());  // ← 여기만 바꿈!
    });

    /**
     * 연결상태 변경 버튼 클릭 시
     * @param mbNo 회원번호
     * @param name 이름
     * @param status 상태 (0: 미지급, 1: 연결, 2: 해지)
     */
    function openStatusModal(mbNo, name, status) {
        $('#modalMemName').text(name);
        $('input[name="modalStatus"][value="' + status + '"]').prop('checked', true);
        $('#reasonSelect').val('회원탈퇴');
        $('#customReason').addClass('ba-off');
        $('#customReason').val('');
        $('#statusModal').data({'mbNo': mbNo, 'status':status}).show();

        toggleReasonSection(status);  // ← 여기만 바꿈!
    }


    // 연결상태 변경 버튼 클릭 시
    $('#submitStatusChange').on('click', function () {
        const newStatus = $('input[name="modalStatus"]:checked').val();
        const status = $('#statusModal').data('status');
        const reason = $('#reasonSelect').val();
        const customReason = $('#customReason').val().trim();

        let finalMemo;
        if (newStatus === '1') {
            finalMemo = reason === '기타' ? customReason : null;
        } else {
            finalMemo = reason === '기타' ? customReason : reason;
        }

        if (newStatus === '2' && finalMemo === '') {
            $j.Common.Util.swalert('해지 사유를 입력해주세요.');
            return;
        }

        if (status === newStatus) {
            $j.Common.Util.swalert('현재 상태와 동일합니다.');
            return;
        }

        const mbNo = $('#statusModal').data('mbNo');

        const data = {
            mbNo: mbNo,
            status: newStatus,
        }

        if (newStatus === '2') {
            data.memo = finalMemo;
        }
        $.ajax({
            type: 'POST',
            url: '/adm/ajax/account/changeBulkStatus',
            data: data,
            success: function (r) {
                if (r.result) {
                    $('#statusModal').hide();
                    $j.Common.Util.swalert(r.message, function () {
                        loadTable();
                    });
                } else {
                    $j.Common.Util.swalert(r.message || '처리에 실패했습니다.');
                }
            }
        });
    });

    /**
     * 상태에 따른 해지사유 input 토글
     * @param status
     */
    function toggleReasonSection(status) {
        if (status === '2') {
            $('#reasonSection').show();
        } else {
            $('#reasonSection').hide();
        }
    }

    /**
     * 데이터 테이블
     */
    function loadTable() {
        const columns = [
            {data: 'num', title: 'No.'},
            {data: 'created_at', title: '생성일', render: v => $j.Common.Util.formatDateTime(v)},
            {data: 'account', title: '계좌'},
            {
                // 이름칸 클릭 = 모바일 입금화면(아래 td 핸들러, 그대로) · #번호 = 회원 팝오버 (칸 클릭과 겹치지 않게 stop)
                data: 'mem_name',
                title: '회원 이름',
                render: (v, t, r) => (v || '') + (parseInt(r.mb_no) ? `<small class="text-muted">#${$j.F.Admin.Member.Pop.cellNo(r.mb_no, { stop: true })}</small>` : '')
            },
            {data: 'status', title: '연결상태',
                render: function (data, type, row) {
                    const statusText = data === '1' ? '연결' : '해지';
                    return `<a href="#" class="ba-status-link" data-mb-no="${row.mb_no}" data-name="${$('<div>').text(row.mem_name || '').html().replace(/"/g, '&quot;')}" data-status="${data}">${statusText}</a>`;
                }
            },
            {data: 'closed_at', title: '해지일'},
            {data: 'manage_name', title: '처리자'},
            {data: 'memo', title: '사유'},
        ];
        if ($table) {
            $table.destroy();
            $('#table').empty();  // 테이블 내용을 비워서 초기화
        }

        $table = new DataTable('#table', {
            autoWidth: false,
            columns: columns,
            rowCallback: formatRow,
            scrollY: 'calc(100vh / var(--adm-zoom, 1) - 230px)', // 화면 높이에 맞게 동적으로 설정
            scrollCollapse: true,
            scrollX: true,
            ajax: {
                url: '/adm/ajax/account/bulkList',
                type: 'post',
                data: (d) => {
                    d.findUserKwd = $('#find-user-kwd').val();
                },
            },
            processing: true,
            serverSide: true,
            // 컬럼 정렬 — 서버가 order[0][column] 을 화이트리스트로 받아 ORDER BY 로 옮긴다
            // (AccountController@bulkList 의 $sortable — 아래 columns 순서와 같아야 한다)
            ordering: true,
            order: [[0, 'desc']],
            displayLength: 20,
            lengthChange: false,
            searching: false
        });
        $('#table tbody').on('click', 'td:nth-child(4)', function (e) {
            const data = $table.row(this).data();
            const mbNo = data.mb_no;

            // iframe 띄우기
            const url = `/m/login/proxy?work_num=${mbNo}&returnurl=${encodeURIComponent('/m/account/deposit')}`;
            $j.F.Admin.Util.userMobile(url);

            e.stopPropagation();
        });
    }


    /**
     * 데이터 열에 따른 포맷 설정
     * @param row 열
     * @param data 데이터
     */
    function formatRow(row, data) {
        $(row).find('td').css('text-align', 'center');
        $(row).find('td:nth-child(4)').addClass('cr-bold-blue').css('cursor','pointer'); // 회원이름
        // 상태에 따라 배경색 설정
        let status = data.status;

        if (status === '2') {
            $(row).find('td').addClass('cr-background-gray');
        }
    }

    /**
     * 인풋 데이터로 검색
     */
    function search() {
        const keyword = $('#find-user-kwd').data('value') || $('#find-user-kwd').val();
        if (keyword) {
            console.log('검색 실행:', keyword);
            $table.ajax.reload();
        }
    }

    // 입력 필드와 리스트를 제어할 인스턴스 생성
    $j.F.Admin.AutoComplete.init({id:'find-user-kwd'});
    }
}
